/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileRtf = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M11.673 11.983c.598 0 1.059.138 1.38.414.323.276.483.668.483 1.173 0 .423-.131.77-.393 1.042a1.5 1.5 0 0 1-.646.393L13.75 17h-1.186l-1.065-1.8-.682-.174V17H9.748v-5.017zm-.856 2.34h.525c.418 0 .709-.053.87-.159.165-.11.248-.301.248-.572 0-.184-.037-.33-.11-.436a.583.583 0 0 0-.345-.227 2.522 2.522 0 0 0-.663-.069h-.525zm7.261-1.428h-1.484V17h-1.076v-4.106h-1.484v-.91h4.044zm3.921 0h-2.125v1.262h1.884v.911h-1.884V17h-1.076v-5.017h3.201z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileRtf as FileRtf };
